import { render, staticRenderFns } from "./AppTabs.vue?vue&type=template&id=7cd90efe&scoped=true&"
import script from "./AppTabs.vue?vue&type=script&lang=ts&"
export * from "./AppTabs.vue?vue&type=script&lang=ts&"
import style0 from "./AppTabs.vue?vue&type=style&index=0&id=7cd90efe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd90efe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
